import { create } from "zustand";

interface ApplyRefcodeState {
  isReferralError: boolean; // Referral not found
  setIsReferralError: (isError: boolean) => void;
}

export const useApplyRefcodeStore = create<ApplyRefcodeState>((set) => ({
  isReferralError: false,
  setIsReferralError: (isError) => set({ isReferralError: isError }),
}));
